import {
  GetUploadChecksResultsResponse,
  MergeAllDraftPartsResponse,
  MergeAllDraftSetsResponse,
  UploadDataAction,
  UploadFileResponse,
  UploadListResponse,
  UploadType,
} from 'api/Responses/BulkUploadResponses';
import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v2/bulk-upload/`;

export interface UploadFileParams {
  gs_location: string;
  upload_type: UploadType;
}

export const getUploadList = async (): Promise<UploadListResponse> => {
  const response = await axiosInstance.get<UploadListResponse>(`${ENDPOINT_PATH}`);

  return response.data;
};

export const uploadFile = async (body: UploadFileParams): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}`, body);
  return response.data;
};

export const getUploadStatus = async (uploadId: string): Promise<UploadFileResponse> => {
  const response = await axiosInstance.get<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/status/`);

  return response.data;
};

export const getUploadChecksResults = async (uploadId: string): Promise<GetUploadChecksResultsResponse> => {
  const response = await axiosInstance.get<GetUploadChecksResultsResponse>(
    `${ENDPOINT_PATH}${uploadId}/checks-result/`,
  );

  return response.data;
};

export type MergeUploadSetDataParams = UploadDataAction[];

export const MergeUploadSetData = async (
  uploadId: string,
  body: MergeUploadSetDataParams,
): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/merge/`, body);

  return response.data;
};

export interface CreateDraftsBodyType {
  items: string[];
}

export const createPartDrafts = async (uploadId: string, body: CreateDraftsBodyType): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/part-drafts/`, body);

  return response.data;
};

export const createSetDrafts = async (uploadId: string, body: CreateDraftsBodyType): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/set-drafts/`, body);

  return response.data;
};

export const createPartAttachmentDrafts = async (
  uploadId: string,
  body: CreateDraftsBodyType,
): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/part-attachments/`, body);

  return response.data;
};

export interface CreateSetSerialNumbersBodyType {
  items: {
    set_code: string;
    set_uss: string;
    move_uss: boolean; // if it's a duplicate and it's in the update list, set this to true
  }[];
}

export const createSetSerialNumbers = async (
  uploadId: string,
  body: CreateSetSerialNumbersBodyType,
): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/set-serial-number/`, body);

  return response.data;
};

export const createSetAttachmentDrafts = async (
  uploadId: string,
  body: CreateDraftsBodyType,
): Promise<UploadFileResponse> => {
  const response = await axiosInstance.post<UploadFileResponse>(`${ENDPOINT_PATH}${uploadId}/set-attachments/`, body);

  return response.data;
};

export const mergeAllDraftParts = async (): Promise<MergeAllDraftPartsResponse> => {
  const response = await axiosInstance.post<MergeAllDraftPartsResponse>(`${ENDPOINT_PATH}parts/merge_all_drafts/`);

  return response.data;
};

export const mergeAllDraftSets = async (): Promise<MergeAllDraftSetsResponse> => {
  const response = await axiosInstance.post<MergeAllDraftSetsResponse>(`${ENDPOINT_PATH}sets/merge_all_drafts/`);

  return response.data;
};
